export default {
      id: "onesite-logo-alt-usage",
      viewBox: "0 0 560 120",
      url: __webpack_public_path__ + "sprite.svg#onesite-logo-alt",
      toString: function () {
        return this.url;
      }
    }